export const REGIONS = ['เหนือ', 'อีสานบน', 'อีสานล่าง', 'กลาง', 'ตะวันออก', 'ตะวันตก', 'ใต้'] as const;
export type Region = typeof REGIONS[number];

export type Branch = {
  id: string;
  name: string;
  region: Region;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export type DailySale = {
  id: string;
  salesDate: string;
  branchId: string;
  branchNameSnapshot: string;
  regionSnapshot: Region;
  salesAmount: number | null;
  paidComplete: boolean;
  posComplete: boolean;
  billComplete: boolean;
  stockAttached: boolean;
  salesLinkUpdated: boolean;
  dailyInspectionAttached: boolean;
  unpluggedPhotoConfirmed: boolean;
  revision: number;
  updatedAt: string;
};

export type EventType = 'sale_changed' | 'checklist_changed' | 'report_copied' | 'daily_sales_reset' | 'branch_created' | 'branch_updated' | 'branch_deactivated';

export type ActivityEvent = {
  eventId: string;
  deviceId: string;
  sessionId: string;
  branchId?: string;
  eventType: EventType;
  occurredAt: string;
  payload: Record<string, unknown>;
};

export type TabId = 'sales' | 'history' | 'manage';

export const emptySale = (branch: Branch, date: string): DailySale => ({
  id: crypto.randomUUID(), salesDate: date, branchId: branch.id,
  branchNameSnapshot: branch.name, regionSnapshot: branch.region, salesAmount: null,
  paidComplete: false, posComplete: false, billComplete: false, stockAttached: false,
  salesLinkUpdated: false, dailyInspectionAttached: false, unpluggedPhotoConfirmed: false,
  revision: 0, updatedAt: new Date().toISOString()
});

export function bangkokDate(date = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
}
